import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response, Headers} from '@angular/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {environment} from '../../environments/environment';
import {AddUserModel, EditUserModel} from './user-details/user-details.model';
import {HttpRequestService} from '../shared/services/http-request.service';
import {TokenManagerService} from '../shared/services/token-login.service';


@Injectable()
export class UserManagementService {
  private getNightKeyUsersURL = environment.apiUrl + '/User/GetNightKeyUsers';
  private deleteUserURL = environment.apiUrl + '/User/Delete';
  private updateNightKeyUserURL = environment.apiUrl + '/User/UpdateNightKeyUser';
  private addNightKeyUserURL = environment.apiUrl + '/User/AddNewNightKeyManager';
  private searchNightkeyUsersURL = environment.apiUrl + '/User/SearchNightKeyUsers';

  constructor(private _http: HttpRequestService) {
  }

  getNightKeyUsers(page, pageSize, sort, desc) {

    return this._http.get(this.getNightKeyUsersURL + '?page=' + page + '&pageSize=' + pageSize + '&sort=' + sort + '&desc=' + desc);
  }

  deleteUser(id: number) {
    return this._http.delete(this.deleteUserURL + '?userId=' + id, true);
  }

  editUser(user: EditUserModel) {
    return this._http.put(this.updateNightKeyUserURL, user, true);
  }

  addUser(newUser: AddUserModel) {
    return this._http.post(this.addNightKeyUserURL, newUser);
  }

  searchNightkeyUsers(query: string, page: number, pageSize: number, sort: string, desc: boolean) {
    return this._http.get(
      this.searchNightkeyUsersURL + '?q=' + query + '&page=' + page + '&pageSize=' + pageSize + '&sort=' + sort + '&desc=' + desc);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-management.service.ts